import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-route1',
    templateUrl: './route1.component.html',
    styleUrls: ['./route1.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Route1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
